import { z } from "zod"

export const BoxTypeOf = "BOX"

export const PhoneNumberWithPrefixSchema = z
  .object({
    number: z.string(),
    countryCode: z.string(),
  })
  .meta({ id: "PhoneNumberWithPrefixSchema" })

export type PhoneNumberWithPrefix = z.infer<typeof PhoneNumberWithPrefixSchema>

export type BoxWaiver = {
  url: string
  key: string
  fileName: string
  originalFileName: string
  uploadedAt: string
  version: number
}
